import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
//import axios from "axios";
import { useSearchParams, useLocation } from "react-router-dom";
import './Certifications.css';
import { certificationsSubmit, getEmployeeDetailsBasedonEmployeeUniqueeId } from "../../../../../../services/employeeCreationService";
import { getAuditLog } from "../../../../../../utils/calculateDaysInMonthUtils";
import ConfirmModal from "../../../../../../components/common/ConfirmModal/ConfirmModal";
import { getFileName } from "../../../../../../utils/validations";

const Certifications = ({ onNext, onPrevious }) => {
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const employeeUniqueId = searchParams.get("employeeUniqueId") || location.state?.applicationId;
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [isDirty, setIsDirty] = useState(false);
    // const [certifications, setCertifications] = useState([
    //     { certificateName: "", certificateNumber: "", issuedBy: "", issuedDate: null, validateDate: null, file: null, errors: {} },
    // ]);
    const [certifications, setCertifications] = useState([
        {
            certificateName: "",
            certificateNumber: "",
            issuedBy: "",
            issuedDate: null,
            validateDate: null,
            file: null,
            certificate: null,
            keyId: `temp-${Date.now()}`,
            errors: {},
        },
    ]);
    const [loading, setLoading] = useState(true);
    const [personalInfo, setPersonalInfo] = useState({
        givenName: "",
        surname: "",
        jobPosition: "",
    });

    const effectRan = useRef(false);
    // === Fetch Existing Data ===
    useEffect(() => {
        const fetchApplicationDetails = async () => {
            if (!employeeUniqueId) {
                setLoading(false);
                return;
            }
            try {
                // const response = await axios.get(
                //     `${process.env.REACT_APP_API_BASE_URL}/api/personal-info/${employeeUniqueId}`
                // );
                // const appData = response.data;
                const appData = await getEmployeeDetailsBasedonEmployeeUniqueeId(employeeUniqueId);
                if (appData.certificates && appData.certificates.length > 0) {
                    const mapped = appData.certificates.map((c) => ({
                        id: c.id,
                        keyId: c.id || `temp-${Date.now()}-${Math.random()}`, // ADD THIS
                        certificateName: c.certificateName || "",
                        certificateNumber: c.certificateNumber || "",
                        issuedBy: c.issuedBy || "",
                        issuedDate: c.issuedDate ? new Date(c.issuedDate) : null,
                        validateDate: c.validateDate ? new Date(c.validateDate) : null,
                        file: null,
                        certificate: c.certificateFileName || null,
                        errors: {},
                    }));
                    setCertifications(mapped);
                }
                setPersonalInfo({
                    givenName: appData.givenName || appData.employee?.firstName || "",
                    surname: appData.surname || appData.employee?.lastName || "",
                    jobPosition: appData.employee?.jobPosition || "",
                });
            } catch (err) {
                console.error("Error fetching certifications:", err);
            } finally {
                setLoading(false);
            }
        };
        if (!effectRan.current) {
            fetchApplicationDetails();
            setIsDirty(false);
        }
        return () => {
            effectRan.current = true;
        }


    }, [employeeUniqueId]);
    const handlePreviousClick = () => {
        if (isDirty) {
            setShowConfirmModal(true); // show confirmation dialog
        } else {
            onPrevious();
        }
    };
    const handleConfirmYes = () => {
        setCertifications([
            { certificateName: "", certificateNumber: "", issuedBy: "", issuedDate: null, validateDate: null, file: null, errors: {} },
        ]);
        setIsDirty(false);
        setShowConfirmModal(false);
        onPrevious();
    };

    // === Confirm "No" → just close modal
    const handleConfirmNo = () => {
        setShowConfirmModal(false);
    };
    // === Handle Input Changes ===
    const handleChange = (index, field, value) => {
        const updated = [...certifications];
        updated[index][field] = value;
        setCertifications(updated);
        setIsDirty(true);
    };

    // === Handle File Change ===
    // const handleFileChange = (index, e) => {
    //     const file = e.target.files[0];
    //     if (file) {
    //         const updated = [...certifications];
    //         updated[index].file = file;
    //         updated[index].errors.file = "";
    //         setCertifications(updated);
    //     }
    //     setIsDirty(true);
    // };

    const handleFileChange = (index, e) => {
        const file = e.target.files[0];
        if (file) {
            setCertifications(prev =>
                prev.map((cert, i) =>
                    i === index ? { ...cert, file } : cert
                )
            );
            setIsDirty(true);
        }
    };

    // // === Add Another Certification Row ===
    // const addCertification = (afterIndex) => {
    //     const newCert = { certificateName: "", certificateNumber: "", issuedBy: "", issuedDate: null, validateDate: null, file: null, errors: {} };
    //     const updated = [...certifications];
    //     updated.splice(afterIndex + 1, 0, newCert); // 👈 insert after current row
    //     setCertifications(updated);
    // };

    const addCertification = (afterIndex) => {
        const newCert = {
            certificateName: "",
            certificateNumber: "",
            issuedBy: "",
            issuedDate: null,
            validateDate: null,
            file: null,
            certificate: null,
            keyId: `temp-${Date.now()}-${Math.random()}`,
            errors: {},
        };
        setCertifications(prev => {
            const updated = [...prev];
            updated.splice(afterIndex + 1, 0, newCert);
            return updated;
        });
    };

    // === Save / Update ===
    // const handleSave = async (goNext = false) => {
    //     const isUpdate = certifications.some((c) => c.id);

    //     const certDetails = certifications.map((c) => ({
    //         certificateName: c.certificateName,
    //         certificateNumber: c.certificateNumber,
    //         issuedBy: c.issuedBy,
    //         issuedDate: c.issuedDate ? c.issuedDate.toISOString().split("T")[0] : null,
    //         validateDate: c.validateDate ? c.validateDate.toISOString().split("T")[0] : null,
    //         id: c.id || null,
    //     }));

    //     const formData = new FormData();

    //     // ✅ FIXED: maintain same number of files as certificateDetails
    //     certifications.forEach((c) => {
    //         if (c.file) {
    //             formData.append("files", c.file);
    //         } else {
    //             // 👇 add empty placeholder to maintain file count
    //             formData.append("files", new Blob([], { type: "application/octet-stream" }), "");
    //         }
    //     });

    //     // append JSON last
    //     const payload = {
    //         certificateDetails: certDetails,
    //         auditLog: getAuditLog(),
    //     };

    //     formData.append(
    //         "request",
    //         new Blob([JSON.stringify(payload)], { type: "application/json" })
    //     );
    //     for (const [key, value] of formData.entries()) {
    //         if (value instanceof File) {
    //             console.log(key, value.name || "(empty placeholder)", "size:", value.size);
    //         } else {
    //             console.log(key, value);
    //         }
    //     }


    //     try {
    //         const response = await certificationsSubmit(employeeUniqueId, formData);
    //         console.log("Response:", response.data);
    //         if (goNext && onNext) onNext();
    //     } catch (err) {
    //         console.error("Error saving certifications:", err);
    //         alert("Failed to save certifications");
    //     }
    // };

  const handleSave = async (goNext = false) => {
  const certDetails = certifications.map((c) => ({
    certificateName: c.certificateName,
    certificateNumber: c.certificateNumber,
    issuedBy: c.issuedBy,
    issuedDate: c.issuedDate ? c.issuedDate.toISOString().split("T")[0] : null,
    validateDate: c.validateDate ? c.validateDate.toISOString().split("T")[0] : null,
    id: c.id || null,
  }));

  const formData = new FormData();

  // Only send files that exist
  const fileIndices = [];
  certifications.forEach((cert, index) => {
    if (cert.file) {
      formData.append("files", cert.file);
      fileIndices.push(index);
    }
  });

  // Send mapping
  if (fileIndices.length > 0) {
    formData.append("fileIndexMapping", JSON.stringify(fileIndices));
  }

  // JSON payload
  const payload = {
    certificateDetails: certDetails,
    auditLog: getAuditLog(),
  };
  formData.append("request", new Blob([JSON.stringify(payload)], { type: "application/json" }));

  // Debug
  console.log("Files sent:", fileIndices);
  for (const [key, value] of formData.entries()) {
    console.log(key, value instanceof File ? value.name : value);
  }

  try {
    const response = await certificationsSubmit(employeeUniqueId, formData);
    console.log("Saved:", response.data);
    if (goNext && onNext) onNext();
  } catch (err) {
    console.error("Save failed:", err);
    alert("Failed to save certifications");
  }
};
    const removeCertification = async (indexToRemove) => {
        const certToRemove = certifications[indexToRemove];

        if (!certToRemove.id) {
            // If this certificate is not yet saved in backend, just remove locally
            setCertifications((prev) => prev.filter((_, i) => i !== indexToRemove));
            return;
        }

        try {
            // Call DELETE API based on certificate id
            await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/certificates/${certToRemove.id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            // Update local state after successful deletion
            setCertifications((prev) => prev.filter((_, i) => i !== indexToRemove));
        } catch (err) {
            console.error("Failed to delete certificate:", err);
            alert("Failed to delete certificate. Please try again.");
        }
    };



    //if (loading) return <div>Loading...</div>;

    return (
        <div className="certificates">
            <div className="certficate-box">
                <div className="expdetails-heading"> <span className="highlight-label">Temporary ID : </span>
                    {employeeUniqueId} - {personalInfo.givenName} {personalInfo.surname} - {personalInfo.jobPosition.designationName}
                </div>
                <h2 className="experiencedetails-heading">Other Certificates</h2>
                <form>
                    {certifications.map((cert, index) => {
                        // check if current row has at least one field filled
                        const isFilled =
                            cert.certificateName.trim() !== "" ||
                            cert.certificateNumber.trim() !== "" ||
                            cert.issuedBy !== "" ||
                            cert.issuedDate !== null ||
                            cert.validateDate !== null ||
                            cert.file !== null;

                        return (
                            <div key={index} className="certification-form">
                                <div className="certificate-container-part">
                                    <div className="certificate-floating-label-container-1">
                                        <input
                                            type="text"
                                            value={cert.certificateName}
                                            onChange={(e) => handleChange(index, "certificateName", e.target.value)}
                                            className="field-input"
                                            placeholder=" "
                                        />
                                        <label>Certificate Name</label>
                                    </div>
                                </div>

                                <div className="certificate-container-part">
                                    <div className="certificate-floating-label-container-1">
                                        <input
                                            type="text"
                                            value={cert.certificateNumber}
                                            onChange={(e) => handleChange(index, "certificateNumber", e.target.value)}
                                            className="field-input"
                                            placeholder=" "
                                        />
                                        <label>Certificate Number</label>
                                    </div>
                                </div>
                                <div className="certificate-container-part">
                                    <div className="certificate-floating-label-container-1">
                                        <input
                                            type="text"
                                            value={cert.issuedBy}
                                            onChange={(e) => handleChange(index, "issuedBy", e.target.value)}
                                            className="field-input"
                                            placeholder=" "
                                        />
                                        <label>Issued By</label>
                                    </div>
                                </div>

                                <div className="certificate-container-part">
                                    <div className={`certificate-floating-label-container-1 ${cert.issuedDate ? "filled" : ""}`}>
                                        <DatePicker
                                            selected={cert.issuedDate}
                                            onChange={(date) => handleChange(index, "issuedDate", date)}
                                            dateFormat="dd-MM-yyyy"
                                            className="field-input"
                                            placeholderText=" "
                                            showYearDropdown
                                            scrollableYearDropdown
                                          yearDropdownItemNumber={15}
                                        />
                                        <label>Issued Date</label>
                                    </div>
                                </div>

                                <div className="certificate-container-part">
                                    <div className={`certificate-floating-label-container-1 ${cert.validateDate ? "filled" : ""}`}>
                                        <DatePicker
                                            selected={cert.validateDate}
                                            onChange={(date) => handleChange(index, "validateDate", date)}
                                            dateFormat="dd-MM-yyyy"
                                            className="field-input"
                                            placeholderText=" "
                                            showYearDropdown
                                            scrollableYearDropdown
                                            yearDropdownItemNumber={15}
                                        />
                                        <label>Validate Date</label>
                                    </div>
                                </div>

                                <div className="certificate-container-part">
                                    <div className="certificate-floating-label-container-1">
                                        <input
                                            type="file"
                                            onChange={(e) => handleFileChange(index, e)}
                                            className="field-input"
                                        />
                                        <label>Upload Certificate</label>
                                        {cert.file ? (
                                            <span className="file-name">{cert.file.name}</span>
                                        ) : cert.certificate ? (
                                            <span className="file-name">{getFileName(cert.certificate)}</span>
                                        ) : null}
                                    </div>
                                </div>

                                {/* Individual + button for this certificate */}
                                {/* <button
                                    type="button"
                                    onClick={() => addCertification(index)}
                                    className="add-cert-button"
                                    disabled={!isFilled} // only enabled if this form has data
                                >
                                    + Add Another
                                </button> */}
                                {/* <br></br> */}
                                <div className="certificate-buttons">
                                    {/* Show "+" button only for the last form */}
                                    {index === certifications.length - 1 && (
                                        <button
                                            type="button"
                                            onClick={() => addCertification(index)}
                                            className="add-cert-button"
                                            disabled={!isFilled} // Only allow if current form is filled
                                        >
                                            +
                                        </button>
                                    )}

                                    {/* Show "–" button for all forms except the first */}
                                    {certifications.length > 0 && (
                                        <button
                                            type="button"
                                            onClick={() => removeCertification(index)}
                                            className="remove-cert-button"
                                        >
                                            –
                                        </button>
                                    )}

                                </div>

                            </div>
                        );
                    })}
                </form>

                <div className="cert-navigate">
                    <button type="button" onClick={handlePreviousClick} className="add-cert-button">
                        Previous
                    </button>
                    <button type="button" onClick={() => handleSave(true)} className="add-cert-button">
                        Save & Next
                    </button>
                </div>

            </div>
            {/* {showConfirmModal && (
                <div className="modal-overlay">
                    <div className="custom-modal">
                        <p>Do you want to clear the form?</p>
                        <div className="modal-buttons">
                            <button type="button" onClick={handleConfirmYes}>
                                Yes
                            </button>
                            <button type="button" onClick={handleConfirmNo}>
                                No
                            </button>
                        </div>
                    </div>
                </div>
            )} */}
            {showConfirmModal && (
                <ConfirmModal
                    message="Do you want to clear the form?"
                    onConfirm={handleConfirmYes}
                    onCancel={handleConfirmNo}
                />
            )}
        </div>
    );
};

export default Certifications;
